import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TrapSection } from '../components/TrapSection';
import { BridgeSection } from '../components/BridgeSection';
import { SystemReveal } from '../components/SystemReveal';
import { DifferenceSection } from '../components/DifferenceSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-navy selection:bg-green/20" data-id="element-176">
      <HeroSection data-id="element-177" />
      <PainSection data-id="element-178" />
      <TrapSection data-id="element-179" />
      <BridgeSection data-id="element-180" />
      <SystemReveal data-id="element-181" />
      <DifferenceSection data-id="element-182" />
      <ForWhomSection data-id="element-183" />
      <FinalCTA data-id="element-184" />
      <Footer data-id="element-185" />
    </main>;
}